import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import magnifierImg from "src/img/magnifier.png";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum, 
    getDatefromWeekNum, 
    getDateEndFromWeekNum, 
    getDateEndFromWeekNum2, 
    myAxios, 
    exclusiveOutisdeKeys, 
    isDevMode, 
    getTimeStamp, 
    MyFormData, 
    statusColorCode, 
    pmEmails, MyDate, 
    standbyWeeks as weeks, 
    outsideEotDefaultEmptyData as defaultEmptyData, 
    boolAndReducer,
    appTitle
} from "src/components/common/functions";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function AllEmergencyOT({ tabTitle }){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const forms = useMyStore((state) => state.outsideserviceEotForms);
    const setForms = useMyStore((state) => state.setOutsideserviceEotForms);   
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [week, setWeek] = useState(() => !weeks.includes(path2)?weeknum((new MyDate()).s()):path2);
    const [category, setCategory] = useState("");
    const [status, setStatus] = useState("");
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    //--------------------------------------------------------------------------------------------
    const curForms = useMemo(() => forms[week] ?? [], [forms, week]);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredForms = useMemo(() => curForms.filter(form => 
        !pmEmails.includes(form.email)
        && (
            status?
                form[week].status === status
                :
                true
        )
        && (
            week?
                (
                    (new Date(getDateEndFromWeekNum2(week)) > new Date(form.hireDate.replace(/-/g, "/")))
                    &&
                    (
                        form.quitDate?
                            (new Date(getDateEndFromWeekNum2(week)) <= new Date(form.quitDate.replace(/-/g, "/")))
                            :
                            true
                    )
                    &&
                    (
                        category?
                            form.outside === category
                            :
                            true
                    )
                )
                :
                true
        ) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(curForms)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ), [curForms, week, status, category, filterWords]);
    const currentForms = filteredForms.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredForms.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("week", week);
            //-------------------------------------------------
            setShowLoading(true);
            const resEOT = await myAxios("outside/eot/allEot.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resEOT) return;
            //-------------------------------------------------
            const ordered = resEOT.data.map(
                personData => Object.fromEntries(
                    Object.entries(personData).map(
                    ([key, value]) => !exclusiveOutisdeKeys.includes(key)?
                    [
                        key, 
                        JSON.parse(
                            value || defaultEmptyData
                        )
                    ]:
                    [key, value]
                    )
                )
            );
            setForms(week, ordered, updateDateTime["Forms"]);
            //-------------------------------------------------------------
            history.replace(`/${path1}/${week}`);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[updateDateTime, week, forms, history, path1, setForms])
   useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return( 
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    All Emergency OT
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {weeks.length?
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setWeek(e.currentTarget.value);
                            setCurrentPage(1);
                            history.replace(`/${path1}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
                :<></>}
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">
                        Status:
                    </label>
                    <select
                        id = "status"
                        className = "form-control w-auto ml-2"
                        value = {status}
                        onChange = {e => {
                            setStatus(e.currentTarget.value);
                            setCurrentPage(1);
                        }}
                    >
                        <option value = "">All</option>
                        <option>Submitted</option>
                        <option value = "Created">Unsubmitted</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "category" className = "mb-0">
                        Category:
                    </label>
                    <select
                        id = "category"
                        className = "form-control w-auto ml-2"
                        value = {category}
                        onChange = {e => {
                            setCategory(e.currentTarget.value);
                            setCurrentPage(1);               
                        }}
                    >
                        <option value = "">All</option>
                        <option value = "locator">Mark and Locator</option>
                        <option value = "qew">QEW</option>
                        <option value = "standby">Standby</option>
                    </select>
                </span>
                {status !== "Created" && filteredForms.length?
                    <Export
                        filteredForms = {filteredForms}
                        week = {week}
                    />
                :<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredForms.length?<div className = "cssLoading">Empty</div>:
                <div className = "overflow-visible">
                    <table className = "table text-center tableAllBorder">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Name</th>
                                <th>Unlock</th>
                                <th>Yard</th>
                                {["Friday", "Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"].map((weekday, i) => 
                                <th key = {i}>
                                    <div>{weekday}</div>
                                    <div>{getDatefromWeekNum(week, i + 4)}</div>
                                </th>)}
                            </tr>
                            </thead>
                            <tbody>
                                {currentForms.sort((a, b) => a.userName > b.userName?1:-1).map((form, formIndex) => 
                                <tr id = {form.email} key = {formIndex}>
                                    <td className = "font-weight-bold">
                                        <UserInfo name = {form.userName} email = {form.email}/>
                                    </td>
                                    <td>
                                        <span className = {`btn btn-${form[week].unlock?"primary":"info"}`} onClick = {async() => {
                                            const formData = new MyFormData();
                                            formData.append("userEmail", form.email);
                                            formData.append("wk", week);
                                            formData.append("unlock", !form[week].unlock?"yes":"no");
                                            //-------------------------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("outside/eot/setEOTUnlock.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //-------------------------------------------------
                                            setForms(week, curForms.map(thisForm => thisForm.email === form.email?
                                                {
                                                    ...thisForm, 
                                                    [week]: {
                                                        ...form[week], 
                                                        unlock: !form[week].unlock
                                                    }
                                                }
                                            :thisForm))
                                        }}>
                                            Set {form[week].unlock?
                                            "Lock"
                                            :
                                            "Unlock"
                                            }
                                        </span>
                                    </td>
                                    <td>
                                        {form[week].form[0].yard}
                                    </td>
                                    {["Friday", "Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"].map((weekday, i) => 
                                    <td key = {i} style = {{color: statusColorCode(form[week]?.status)}}>
                                        <span className = "mx-2">{form[week].form[i].availablity}</span>
                                    </td>)}
                                </tr>
                                )}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredForms.length?
                <Footer
                    length = {filteredForms.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}